import React from 'react';
import { Avatar } from '@mui/material';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import type { ClientNotification } from '../../types/clientNotification';
import { CWY_COLORS } from '../../theme/colors';

function initials(name?: string): string {
  if (!name?.trim()) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

export const NotificationAvatar: React.FC<{ notification: ClientNotification }> = ({ notification }) => {
  const { category, type, metadata } = notification;
  const actorName = metadata?.actor_name;

  if (type === 'support_message') {
    return (
      <Avatar sx={{ width: 48, height: 48, bgcolor: CWY_COLORS.red, fontSize: '1rem' }}>C</Avatar>
    );
  }

  if (category === 'messaging' || type === 'community_message') {
    return (
      <Avatar sx={{ width: 48, height: 48, bgcolor: '#5c6bc0', fontSize: '0.875rem' }}>
        {initials(actorName || metadata?.product_name)}
      </Avatar>
    );
  }

  const iconSx = { fontSize: 22, color: '#fff' };

  if (category === 'community') {
    return (
      <Avatar sx={{ width: 48, height: 48, bgcolor: '#007185' }}>
        <GroupsOutlinedIcon sx={iconSx} />
      </Avatar>
    );
  }

  if (category === 'appointment') {
    return (
      <Avatar sx={{ width: 48, height: 48, bgcolor: '#2e7d32' }}>
        <EventAvailableOutlinedIcon sx={iconSx} />
      </Avatar>
    );
  }

  if (category === 'store') {
    return (
      <Avatar sx={{ width: 48, height: 48, bgcolor: '#e65100' }}>
        <ShoppingBagOutlinedIcon sx={iconSx} />
      </Avatar>
    );
  }

  if (category === 'vault' || category === 'payment') {
    return (
      <Avatar sx={{ width: 48, height: 48, bgcolor: '#6a1b9a' }}>
        <AccountBalanceWalletOutlinedIcon sx={iconSx} />
      </Avatar>
    );
  }

  return (
    <Avatar sx={{ width: 48, height: 48, bgcolor: CWY_COLORS.navyLight }}>
      <ChatOutlinedIcon sx={iconSx} />
    </Avatar>
  );
};
